export enum StoreStatus {
  PENDING = "PENDING",
  ACTIVE = "ACTIVE",
  SUSPENDED = "SUSPENDED",
  DELETED = "DELETED",
  INACTIVE = "INACTIVE"
}

/** Subset of `com.kivuims.identitymanagementservice.models.Role` / GraphQL `UserRole` (container UI roles). */
export enum UserRole {
  COMPANY_ADMIN = "COMPANY_ADMIN",
  STORE_ADMIN = "STORE_ADMIN",
  INVENTORY_CLERK = "INVENTORY_CLERK",
  WAREHOUSE_MANAGER = "WAREHOUSE_MANAGER",
  SALES_PROCUREMENT = "SALES_PROCUREMENT",
  BUYER = "BUYER",
  ANALYST = "ANALYST"
}

export enum AccountStatus {
  INVITED = "INVITED",
  ACTIVE = "ACTIVE",
  SUSPENDED = "SUSPENDED",
  DELETED = "DELETED"
}
